<template>
  <div class="orderInfoContainer"
    :class="{ 'orderInfoContainer--Mobile': isScreenSmall, 'orderInfoContainer--TwoColumns': !showBilling }">
    <!-- container-fluid class is needed for datalist dropdown to appear (This do be kinda weird doe) -->
    <!-- Billing -->
    <div class="orderColumn" :class="{ 'mx-2': !isScreenSmall }" id="billing" v-show="showBilling">
      <h4 class="text-center kne-title my-3">{{ $t('OrderPending.pickupDeliveryTab.billing') }}</h4>
      <div class="d-flex align-items-center">
        <regular-datalist :value="datalist.billing" @input="setAndSearch($event, 'billing');"
          :disabled="(isPendingOrder && !!order.payerName) || billingSame" :originalList="clientAccounts" :secondList="[]"
          :placeholder="$t('OrderPending.pickupDeliveryTab.name')" class="form-group billing-datalist" />
        <hover-tool-tip
          v-if="order.applyFuelCharge === false"
          :text="'Fuel Charge Included'"
          :top="true"
          :iconColor="'red'"
          :iconClass="'fa-gas-pump'"
          clickable
          class="ms-2 flex-shrink-0"
        />
      </div>

      <identity-picker
        v-if="allowIdentities && realNameOf('payer')"
        :realName="realNameOf('payer')"
        :value="identityOf('payer')"
        :identities="identitySources.payer.identities"
        :isDefault="identityDefaults.payer"
        :showDefault="showIdentityDefault('payer')"
        @input="onIdentityInput('payer', $event)"
        @update:isDefault="identityDefaults.payer = $event"
      />

      <div class="new-dealer form-group">
        <p>{{ $t('OrderPending.addDealer') }}</p>
        <button id="addOrder" class="btn btn-kne-orange me-2" @click="isAddDealer = true">
          <i class="fa fa-plus-circle fa-lg" aria-hidden="true" /> {{ $t('Account.add_dealer') }}
        </button>
      </div>

      <!-- <regular-input
        :value="order.payerName"
        @input="order.payerName = $event"
        :disabled="true"
        type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.name') + '*'" class="form-group" :class="{'input--missing' : order.payerName === ''}"/> -->
      <regular-input :value="order.payerAddress" @input="order.payerAddress = $event" :disabled="true" type="text"
        :placeholder="$t('OrderPending.pickupDeliveryTab.address') + '*'" class="form-group"
        :class="{ 'input--missing': order.payerAddress === '' }" />
      <regular-input :value="order.payerCity" @input="order.payerCity = $event" :disabled="true" type="text"
        :placeholder="$t('OrderPending.pickupDeliveryTab.city') + '*'" class="form-group"
        :class="{ 'input--missing': order.payerCity === '' }" />
      <regular-input :value="order.payerPostcode" @input="order.payerPostcode = $event" :disabled="true" type="text"
        :placeholder="$t('OrderPending.pickupDeliveryTab.postal_code') + '*'" class="form-group"
        :class="{ 'input--missing': order.payerPostcode === '' }" />
      <regular-input :value="order.payerProvince" @input="order.payerProvince = $event" :disabled="true" type="text"
        :placeholder="$t('OrderPending.pickupDeliveryTab.province') + '*'" class="form-group"
        :class="{ 'input--missing': order.payerProvince === '' }" />
      <regular-input :value="order.payerCountry" @input="order.payerCountry = $event" :disabled="true" type="text"
        :placeholder="$t('OrderPending.pickupDeliveryTab.country') + '*'" class="form-group"
        :class="{ 'input--missing': order.payerCountry === '' }" />
      <regular-input :value="order.payerEmail" @input="order.payerEmail = $event" :disabled="true" type="text"
        :placeholder="$t('OrderPending.pickupDeliveryTab.email')" class="form-group" />
      <regular-input :value="order.payerPhone" @input="order.payerPhone = $event" :disabled="true" type="tel"
        :placeholder="$t('OrderPending.pickupDeliveryTab.phone')" class="form-group" />
      <regular-input :value="order.payerFax" @input="order.payerFax = $event" :disabled="true" type="tel"
        :placeholder="$t('OrderPending.pickupDeliveryTab.fax')" class="form-group" />

      <regular-input :value="getPayerZone" @input="order.payerZone = $event" type="text"
        :placeholder="$t('OrderPending.pickupDeliveryTab.zone')" :disabled="true" class="form-group mb-0 disabled" />

        <p v-if="isZoneVerification && !isBillingZone" class="mt-2 mb-2 text-danger">
          {{ $t('OrderPending.pickupDeliveryTab.zoneNotFound') }}
          <span class="define-zone-text" @click="$emit('toggleZoneModal', 'BILLING')">Define</span>
        </p>
        <p v-else-if="!isBillingZone" class="mt-2 mb-2 text-warning">
          {{ $t('OrderPending.pickupDeliveryTab.zoneNotFound') }}
        </p>

      <!-- <regular-input
        :value="order.payerContact"
        @input="order.payerContact = $event"
        :disabled="billingSame"
        type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.contact')" class="form-group"/> -->
      <!-- <regular-checkbox
        :checked="billingSame"
        @change="billingSame = $event"
        :label="$t('OrderPending.pickupDeliveryTab.same_as_delivery')" class=""/> -->
        
        <!-- <div v-show="isSageOne" class="mt-3">
          <regular-datalist
            :value="sage.name"
            @input="setSage($event)"
            :sageOne="sageone"
            :placeholder="'Sage ID'"
            class="datalist"/>
        </div>
        <p v-show="order.payer && (!order.payerContact || noLogisticsContact())" class="my-2 text-warning">
          {{ $t('OrderCurrent.no_payer_contact_error') }}
        </p>
        <p v-show="isSageOne && order.payer && !sage.key" class="my-2 text-danger">
          {{ $t('OrderCurrent.no_sage_id_error') }}
        </p> -->

      <!-- Billing Comment Box -->
      <div v-if="order.billingComment" class="billing-comment-box mt-3">
        <div class="billing-comment-header">
          <i class="fa fa-comment-alt me-2"></i>
          {{ $t('OrderPending.pickupDeliveryTab.billing_comment') || 'Billing Comment' }}
        </div>
        <div class="billing-comment-content">
          {{ order.billingComment }}
        </div>
      </div>

    </div>

    <!-- Pickup -->
    <div class="orderColumn" id="pickup" :class="{ 'mx-2': !isScreenSmall }">
      <h4 class="text-center kne-title my-3">{{ $t('OrderPending.pickupDeliveryTab.pickup') }}</h4>
      <regular-datalist class="mt-3 form-group" :value="datalist.pickup"
        :disabled="(isPendingOrder || isFromMarketplace || (!isPendingOrder && showBilling && !isBilling)) && !((this.initialOrder.transmitterAddress || this.initialOrder.transmitterCountry) && (!this.initialOrder.transmitterLat || !this.initialOrder.transmitterLong))"  @input="setAndSearch($event, 'pickup')"
        :originalList="{}" :secondList="addressbook" :placeholder="$t('AddressBook.title')" />

      <div>
        <vue-google-autocomplete ref="AutocompleteSearchPickup" class="form-control border my-3" id="orderTransmitter"
          :disabled="(isPendingOrder || isFromMarketplace || (!isPendingOrder && showBilling && !isBilling)) && !((this.initialOrder.transmitterAddress || this.initialOrder.transmitterCountry) && (!this.initialOrder.transmitterLat || !this.initialOrder.transmitterLong))" :placeholder="$t('AddressBook.search_autocomplete')"
          v-on:placechanged="onVGA_TRMTRSearch" :country="['ca', 'us']" :fields="autocompleteSearchFields">
        </vue-google-autocomplete>

        <regular-select class="my-3" v-if="arrOfTransmitterPlaces.length > 0" :value="realNameOf('transmitter')"
          :disabled="(isPendingOrder || isFromMarketplace || (!isPendingOrder && showBilling && !isBilling)) && !((this.initialOrder.transmitterAddress || this.initialOrder.transmitterCountry) && (!this.initialOrder.transmitterLat || !this.initialOrder.transmitterLong))"
          @change="onCompanyNameSelect($event, baseStr.transmitter); setRealNameOf('transmitter', $event);"
          :placeholder="$t('NewOrder.multiple_select') + '*'">
          <option v-for="place in arrOfTransmitterPlaces" :key="place.name" :value="place.name">{{ place.name }}</option>
        </regular-select>
        <regular-input id="trName" :value="realNameOf('transmitter')"
          :disabled="(isPendingOrder || isFromMarketplace || (!isPendingOrder && showBilling && !isBilling)) && !((this.initialOrder.transmitterAddress || this.initialOrder.transmitterCountry) && (!this.initialOrder.transmitterLat || !this.initialOrder.transmitterLong))"
          @input="setRealNameOf('transmitter', $event); onInputEntered()" type="text"
          :placeholder="$t('OrderPending.pickupDeliveryTab.name') + '*'" class="form-group"
          :class="{ 'input--missing': order.transmitterName === '' }" />

        <identity-picker
          v-if="allowIdentities && realNameOf('transmitter')"
          :realName="realNameOf('transmitter')"
          :value="identityOf('transmitter')"
          :identities="identitySources.transmitter.identities"
          :isDefault="identityDefaults.transmitter"
          :showDefault="showIdentityDefault('transmitter')"
          @input="onIdentityInput('transmitter', $event)"
          @update:isDefault="identityDefaults.transmitter = $event"
        />

        <regular-input id="trAddress" :value="order.transmitterAddress"
          @input="order.transmitterAddress = $event; onInputEntered()" :disabled="isTransmitterInfo.address" type="text"
          :placeholder="$t('OrderPending.pickupDeliveryTab.address') + '*'" class="form-group"
          :class="{ 'input--missing': order.transmitterAddress === '' }" />
        <regular-input id="trCity" :value="order.transmitterCity"
          @input="order.transmitterCity = $event; onInputEntered()" :disabled="isTransmitterInfo.city" type="text"
          :placeholder="$t('OrderPending.pickupDeliveryTab.city') + '*'" class="form-group"
          :class="{ 'input--missing': order.transmitterCity === '' }" />
        <regular-input id="trPostcode" :value="order.transmitterPostcode"
          @input="order.transmitterPostcode = $event; onInputEntered()" :disabled="isTransmitterInfo.postcode"
          type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.postal_code') + '*'" class="form-group"
          :class="{ 'input--missing': order.transmitterPostcode === '' }" />
        <regular-input id="trProvince" :value="order.transmitterProvince"
          @input="order.transmitterProvince = $event; onInputEntered()" :disabled="isTransmitterInfo.province"
          type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.province') + '*'" class="form-group"
          :class="{ 'input--missing': order.transmitterProvince === '' }" />
        <regular-input id="trCountry" :value="order.transmitterCountry"
          @input="order.transmitterCountry = $event; onInputEntered()" :disabled="isTransmitterInfo.country" type="text"
          :placeholder="$t('OrderPending.pickupDeliveryTab.country') + '*'" class="form-group"
          :class="{ 'input--missing': order.transmitterCountry === '' }" />

        <!-- <label v-show="feedbackMessage && order.transmitterEmail" class="mt-0" for="transmitterEmail">
            {{feedbackMessage}}
            <hover-tool-tip
              class=""
              :text="$t('NewOrder.email_format_required')"
              top
              right
            />
          </label>
          <div class="flex-row" id="transmitterEmail">
            <regular-input
              :value="order.transmitterEmail"
              @input="order.transmitterEmail = $event"
              type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.add_email')" class="w-100"
              @keyup.enter.native="onEmailAdd(order.transmitterEmail, baseStr.transmitter)"
            />
              <hover-tool-tip
                class="mx-2"
                :text="$t('NewOrder.email_tooltip')"
                top
                right
              />
              <button class="btn btn-kne-green ml-2" @click="onEmailAdd(order.transmitterEmail, baseStr.transmitter)"><i class="fa fa-solid fa-plus" /></button>
          </div> -->

        <add-contact :contactList.sync="order.transmitterContacts" :isAddContact.sync="isAddTransmitterContact"
          :isEditContact.sync="isEditTransmitterContact" :editIndex="transmitterEditIndex"
          @update:contactList="updateContactList" />
        <div v-if="!isAddTransmitterContact && !isEditTransmitterContact" class="my-2 ml-1">
          <div v-for="(contact, index) in order.transmitterContacts" :key="index" class="contact-display">
            <p>{{ contact.name }}</p>
            <div class="flex gap-2">
              <button @click="editTransmitterContact(index)"><i class="fa fa-pencil"></i></button>
              <button @click="deleteContact(index)"><i class="fa fa-trash"></i></button>
            </div>
          </div>
        </div>

        <!-- <div class="flex-row my-1" v-for="(email, index) in order.transmitterEmailList" :key="index">
            <i class="w-100 m-1 mt-2">{{email}}</i>
            <hr class="hrLine w-100 mx-3">
            <label class="custom-control custom-checkbox my-2 ml-2 mr-0">
              <input :value="email" v-model="selectedEmails" type="checkbox" @change="onEmailSelected(selectedEmails)" class="custom-control-input">
              <span class="custom-control-indicator"></span>
            </label>
            <button class="btn btn-kne-red py-1" @click="onEmailRemove(index, baseStr.transmitter)">X</button>
          </div> -->

        <regular-input :value="order.transmitterPhone" @input="order.transmitterPhone = $event" type="tel"
          :placeholder="$t('OrderPending.pickupDeliveryTab.phone')" class="form-group mt-3" />
        <regular-input :value="order.transmitterFax" @input="order.transmitterFax = $event" type="tel"
          :placeholder="$t('OrderPending.pickupDeliveryTab.fax')" class="form-group" />
        <regular-input :value="order.transmitterContact" @input="order.transmitterContact = $event" type="text"
          :placeholder="$t('OrderPending.pickupDeliveryTab.contact')" class="form-group mt-3" />
        <regular-input :value="order.transmitterZone" @input="order.transmitterZone = $event" type="text"
          :placeholder="$t('OrderPending.pickupDeliveryTab.zone')" :disabled="true" class="form-group mb-0 disabled" />
          <p v-if="isZoneVerification && (order.transmitterAddress || order.transmitterCountry || order.transmitterCity) && (!order.transmitterLat || !order.transmitterLong)" class="mb-2 text-warning">
            {{ $t('OrderPending.pickupDeliveryTab.re_enter_address') }}
          </p>
          <p v-else-if="isZoneVerification && (order.transmitterAddress || order.transmitterCountry || order.transmitterCity) && !this.order.transmitterZoneId" class="mb-2 text-danger">
            {{ $t('OrderPending.pickupDeliveryTab.zoneNotFound') }}
            <span class="define-zone-text"
              @click="$emit('toggleZoneModal', 'PICKUP')">{{ $t('OrderPending.pickupDeliveryTab.add_zone') }}</span>
          </p>
          <p v-else-if="!isZoneVerification && (order.transmitterAddress || order.transmitterCountry || order.transmitterCity) && !order.transmitterZoneId" class="mb-2 text-warning">
            {{ $t('OrderPending.pickupDeliveryTab.zoneNotFound') }}
          </p>
        <regular-checkbox :checked="pickupSave" @change="pickupSave = $event"
          :label="$t('OrderPending.pickupDeliveryTab.save_dealer')" />
        <div
          v-if="showPickupLogisticsEmailOption"
          class="logistics-email-choice mt-2"
          :class="{'logistics-email-choice--invalid': isLogisticsContactSourceInvalid('pickup')}"
        >
          <regular-checkbox
            :checked="logisticsEmailSource === 'pickup'"
            @change="selectLogisticsEmailSource('pickup', $event)"
            :label="$t('OrderPending.pickupDeliveryTab.send_logistics_emails_to', {company: realNameOf('transmitter')})"
          />
          <p v-if="isLogisticsContactSourceInvalid('pickup')" class="text-danger mb-0">
            {{ $t('OrderPending.pickupDeliveryTab.logistics_contact_required') }}
          </p>
        </div>
      </div>
    </div>

    <!-- Delivery -->
    <div class="orderColumn" :class="{ 'mx-2': !isScreenSmall }" id="delivery">
      <h4 class="text-center kne-title my-3">{{ $t('OrderPending.pickupDeliveryTab.delivery') }}</h4>
      <regular-datalist :value="datalist.delivery" @input="setAndSearch($event, 'delivery')"
        :disabled="(isPendingOrder || isFromMarketplace || (!isPendingOrder && showBilling && !isBilling)) && !((this.initialOrder.receiverAddress || this.initialOrder.receiverCountry) && (!this.initialOrder.receiverLat || !this.initialOrder.receiverLong))"  :originalList="{}" :secondList="addressbook"
        :placeholder="$t('AddressBook.title')" class="form-group" />
      <div>
        <vue-google-autocomplete class="form-control border my-3" id="orderReceiver"
          :disabled="(isPendingOrder || isFromMarketplace || (!isPendingOrder && showBilling && !isBilling)) && !((this.initialOrder.receiverAddress || this.initialOrder.receiverCountry) && (!this.initialOrder.receiverLat || !this.initialOrder.receiverLong))"  ref="AutocompleteSearchDelivery"
          :placeholder="$t('AddressBook.search_autocomplete')" v-on:placechanged="onVGA_RCVRSearch"
          :country="['ca', 'us']" :fields="autocompleteSearchFields">
        </vue-google-autocomplete>

        <regular-select class="my-3" v-if="arrOfReceiverPlaces.length > 0" :value="realNameOf('receiver')"
          :disabled="(isPendingOrder || isFromMarketplace || (!isPendingOrder && showBilling && !isBilling)) && !((this.initialOrder.receiverAddress || this.initialOrder.receiverCountry) && (!this.initialOrder.receiverLat || !this.initialOrder.receiverLong))"
          @change="onCompanyNameSelect($event, baseStr.receiver); setRealNameOf('receiver', $event);"
          :placeholder="$t('NewOrder.multiple_select') + '*'">
          <option v-for="place in arrOfReceiverPlaces" :key="place.name" :value="place.name">{{ place.name }}</option>
        </regular-select>

        <regular-input id="reName" :value="realNameOf('receiver')" :disabled="(isPendingOrder || isFromMarketplace || (!isPendingOrder && showBilling && !isBilling)) && !((this.initialOrder.receiverAddress || this.initialOrder.receiverCountry) && (!this.initialOrder.receiverLat || !this.initialOrder.receiverLong))"
          @input="setRealNameOf('receiver', $event); onInputBillingSame(); onInputEntered()" type="text"
          :placeholder="$t('OrderPending.pickupDeliveryTab.name') + '*'" class="form-group"
          :class="{ 'input--missing': order.receiverName === '' }" />

        <identity-picker
          v-if="allowIdentities && realNameOf('receiver')"
          :realName="realNameOf('receiver')"
          :value="identityOf('receiver')"
          :identities="identitySources.receiver.identities"
          :isDefault="identityDefaults.receiver"
          :showDefault="showIdentityDefault('receiver')"
          @input="onIdentityInput('receiver', $event)"
          @update:isDefault="identityDefaults.receiver = $event"
        />
        <regular-input id="reAddress" :value="order.receiverAddress"
          @input="order.receiverAddress = $event; onInputBillingSame(); onInputEntered()"
          :disabled="isReceiverInfo.address" type="text"
          :placeholder="$t('OrderPending.pickupDeliveryTab.address') + '*'" class="form-group"
          :class="{ 'input--missing': order.receiverAddress === '' }" />
        <regular-input id="reCity" :value="order.receiverCity"
          @input="order.receiverCity = $event; onInputBillingSame(); onInputEntered()" :disabled="isReceiverInfo.city"
          type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.city') + '*'" class="form-group"
          :class="{ 'input--missing': order.receiverCity === '' }" />
        <regular-input id="rePostcode" :value="order.receiverPostcode"
          @input="order.receiverPostcode = $event; onInputBillingSame(); onInputEntered()"
          :disabled="isReceiverInfo.postcode" type="text"
          :placeholder="$t('OrderPending.pickupDeliveryTab.postal_code') + '*'" class="form-group"
          :class="{ 'input--missing': order.receiverPostcode === '' }" />
        <regular-input id="reProvince" :value="order.receiverProvince"
          @input="order.receiverProvince = $event; onInputBillingSame(); onInputEntered()"
          :disabled="isReceiverInfo.province" type="text"
          :placeholder="$t('OrderPending.pickupDeliveryTab.province') + '*'" class="form-group"
          :class="{ 'input--missing': order.receiverProvince === '' }" />
        <regular-input id="reCountry" :value="order.receiverCountry"
          @input="order.receiverCountry = $event; onInputBillingSame(); onInputEntered()"
          :disabled="isReceiverInfo.country" type="text"
          :placeholder="$t('OrderPending.pickupDeliveryTab.country') + '*'" class="form-group"
          :class="{ 'input--missing': order.receiverCountry === '' }" />

        <!-- <label v-show="feedbackMessage && order.receiverEmail" class="mt-0" for="receiverEmail">{{feedbackMessage}}
            <hover-tool-tip
              class="mx-2"
              :text="$t('NewOrder.email_format_required')"
              top
              right
            />
          </label>
          <div class="flex-row" id="receiverEmail">
            <regular-input
              :value="order.receiverEmail"
              @input="order.receiverEmail = $event; onInputBillingSame()"
              type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.email')" class="w-100"
              @keyup.enter.native="onEmailAdd(order.receiverEmail, baseStr.receiver)"
            />
            <hover-tool-tip
              class="mx-2"
              :text="$t('NewOrder.email_tooltip')"
              top
              left
            />
            <button class="btn btn-kne-orange ml-1" @click="onEmailAdd(order.receiverEmail, baseStr.receiver)">+</button>
          </div>
  
          <div class="flex-row my-1" v-for="(email, index) in order.receiverEmailList" :key="index">
            <i class="w-100 m-1">{{email}}</i>
            <hr class="hrLine w-100 mx-3">
            <label class="custom-control custom-checkbox my-2 ml-2 mr-0">
              <input :value="email" v-model="selectedEmails" @change="onEmailSelected(selectedEmails)" type="checkbox" class="custom-control-input">
              <span class="custom-control-indicator"></span>
            </label>
            <button class="btn btn-kne-red py-1" @click="onEmailRemove(index, baseStr.receiver)">X</button>
          </div> -->

        <add-contact :contactList.sync="order.receiverContacts" :isAddContact.sync="isAddReceiverContact"
          :isEditContact.sync="isEditReceiverContact" :editIndex.sync="receiverEditIndex"
          @update:contactList="updateReceiverContactList" />

        <div v-if="!isAddReceiverContact && !isEditReceiverContact" class="my-2 ml-1">
          <div v-for="(contact, index) in order.receiverContacts" :key="index" class="contact-display">
            <p>{{ contact.name }}</p>
            <div class="flex gap-2">
              <button @click="editReceiverContact(index)"><i class="fa fa-pencil"></i></button>
              <button @click="deleteReceiverContact(index)"><i class="fa fa-trash"></i></button>
            </div>
          </div>
        </div>

        <regular-input :value="order.receiverPhone" @input="order.receiverPhone = $event; onInputBillingSame()"
          type="tel" :placeholder="$t('OrderPending.pickupDeliveryTab.phone')" class="form-group mt-3" />
        <regular-input :value="order.receiverFax" @input="order.receiverFax = $event; onInputBillingSame()" type="tel"
          :placeholder="$t('OrderPending.pickupDeliveryTab.fax')" class="form-group" />
        <regular-input :value="order.receiverContact" @input="order.receiverContact = $event; onInputBillingSame()"
          type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.contact')" class="form-group mt-3" />
        <regular-input :value="order.receiverZone" @input="order.receiverZone = $event" type="text"
          :placeholder="$t('OrderPending.pickupDeliveryTab.zone')" :disabled="true" class="form-group mb-0 disabled" />
          <p v-if="isZoneVerification && (order.receiverAddress || order.receiverCountry || order.receiverCity) && (!order.receiverLat || !order.receiverLong)" class="mb-2 text-warning">
            {{ $t('OrderPending.pickupDeliveryTab.re_enter_address') }}
          </p>
          <p v-else-if="isZoneVerification && (order.receiverAddress || order.receiverCountry || order.receiverCity) && !this.order.receiverZoneId" class="mb-2 text-danger">
            {{ $t('OrderPending.pickupDeliveryTab.zoneNotFound') }}
            <span class="define-zone-text" @click="$emit('toggleZoneModal', 'DELIVERY')">
              {{ $t('OrderPending.pickupDeliveryTab.add_zone') }}
            </span>
          </p>
          <p v-else-if="!isZoneVerification && (order.receiverAddress || order.receiverCountry || order.receiverCity) && !order.receiverZoneId" class="mb-2 text-warning">
            {{ $t('OrderPending.pickupDeliveryTab.zoneNotFound') }}
          </p>
        <regular-checkbox :checked="deliverySave" @change="deliverySave = $event"
          :label="$t('OrderPending.pickupDeliveryTab.save_dealer')" class="" />
        <div
          v-if="showDeliveryLogisticsEmailOption"
          class="logistics-email-choice mt-2"
          :class="{'logistics-email-choice--invalid': isLogisticsContactSourceInvalid('delivery')}"
        >
          <regular-checkbox
            :checked="logisticsEmailSource === 'delivery'"
            @change="selectLogisticsEmailSource('delivery', $event)"
            :label="$t('OrderPending.pickupDeliveryTab.send_logistics_emails_to', {company: realNameOf('receiver')})"
          />
          <p v-if="isLogisticsContactSourceInvalid('delivery')" class="text-danger mb-0">
            {{ $t('OrderPending.pickupDeliveryTab.logistics_contact_required') }}
          </p>
        </div>
      </div>
    </div>

    <!-- Price configuration message -->
    <div class="price-config-message" v-if="!showBilling && vehiclePriceCheck(order.regularPrice) && isZoneVerification">
      <p class="mb-2 text-danger">
        {{ $t('OrderCurrent.modal.noPriceErrorMessage') }}
        <span style="text-decoration: underline; cursor: pointer;"
          @click="openModal()">{{ $t('OrderCurrent.modal.configureZonePrice') }}</span>
      </p>
    </div>
    <zone-pricing-modal v-if="showZoneModal" :zone="this.transmitterZone" :toZone="order.receiverZoneId" :allowActions="true"
      @closeModal="closeModal"></zone-pricing-modal>
    <discount-zone-pricing-modal v-if="showDealerZoneModal" :zone="transmitterZone" :toZone="order.receiverZoneId"
      :discountedZones="selectedDealer.discountedZones || []" :accountName="selectedDealer.name"
      :accountId="order.payer" @closeModal="closeModal">
    </discount-zone-pricing-modal>
    <modal :title="$t('Add New Dealer')" v-if="isAddDealer" @close-request="isAddDealer = false;" closableBackdrop
      closable>
      <new-dealer-modal ref="transporterAccountFormJS" :isFromNewOrder="true"
        @closeAddDealerModal="closeAddDealerModal">
      </new-dealer-modal>
    </modal>
  </div>

</template>

<script>
import hoverToolTip from '../../basic-components/hoverToolTip.vue'
import regularInput from '../../basic-components/regularInput.vue'
import regularCheckbox from '../../basic-components/regularCheckbox.vue'
import regularTextarea from '../../basic-components/regularTextarea.vue'
import regularSelect from '../../basic-components/regularSelect.vue'
import regularInputNumber from '../../basic-components/regularInputNumber.vue'
import zonePricingModal from '../Modal-templates/ZonePricing-modal.vue'
import DiscountZonePricingModal from '../Modal-templates/DiscountZonePricing-modal.vue'
import addContact from '../../basic-components/addContact.vue'
import identityPicker from '../../basic-components/identityPicker.vue'
import Modal from '../../interface-components/Modal.vue'
import NewDealerModal from '../Modal-templates/NewDealer-modal.vue'
import { BasicSelect } from 'vue-search-select'
import VueGoogleAutocomplete from 'vue-google-autocomplete'
import { gmapApi } from 'vue2-google-maps'
import {db} from '../../../../firebase'
import {point as turfPoint, polygon as turfPolygon, booleanPointInPolygon} from '@turf/turf'
import { IDENTITY_SECTIONS, getRealName, getIdentityName, setRealName, setIdentity, clearIdentity } from '../../../../utils/orderIdentity'
// import _ from 'lodash'

const emptyIdentitySource = () => ({ path: '', identities: [], defaultIdentity: '', defaultChecked: false })

const normalizeIdentityList = (value) => {
  const list = Array.isArray(value) ? value : (value && typeof value === 'object' ? Object.values(value) : [])
  return list.filter(name => typeof name === 'string' && name.trim())
}

export default {
  components: {
    hoverToolTip,
    regularInput,
    regularCheckbox,
    regularTextarea,
    regularSelect,
    addContact,
    identityPicker,
    regularInputNumber,
    VueGoogleAutocomplete,
    BasicSelect,
    zonePricingModal,
    DiscountZonePricingModal,
    Modal,
    NewDealerModal
  },

  props: {
    order: Object,
    originalList: Object,
    addressbook: Array,
    showBilling: {
      type: Boolean,
      required: true
    },
    isPendingOrder: {
      required: false,
      default: false,
      type: Boolean
    },
    isFromMarketplace: {
      required: false,
      default: false,
      type: Boolean
    },
    isFromDispatch: {
      required: false,
      default: false,
      type: Boolean
    },
    isModification: {
      required: false,
      default: false,
      type: Boolean
    },
    allowIdentities: {
      required: false,
      default: false,
      type: Boolean
    },
    calculateZonePrice: {
      required: false,
      type: Function,
      defaule: () => {}
    },
    vehicles: {
      type: Array,
      required: false,
      default: () => []
    },
    selectedDealer: Object,
    zoneData: Object
  },

  data () {
    return {
      pickupSave: true,
      arrOfTransmitterPlaces: [],
      isTransmitterInfo: {
        address: true,
        postcode: true,
        city: true,
        province: true,
        country: true
      },
      transmitterZone: {},
      initialOrder: {},
      isAddTransmitterContact: false,
      isAddReceiverContact: false,
      isEditTransmitterContact: false,
      isEditReceiverContact: false,
      isAddDealer: false,
      transmitterEditIndex: 0,
      receiverEditIndex: 0,
      deliverySave: true,
      arrOfReceiverPlaces: [],
      isReceiverInfo: {
        address: true,
        postcode: true,
        city: true,
        province: true,
        country: true
      },
      billingSame: false,
      datalist: {
        pickup: '',
        pickupUid: '',
        delivery: '',
        deliveryUid: '',
        billing: '',
        billingUid: ''
      },
      sage: {
          name: '',
          key: ''
        },
      sageone: [],
      pickupZone: '',
      dropZone: '',
      zones: [],
      selectedEmails: [],
      feedbackMessage: '',
      baseStr: {
        transmitter: 'Transmitter',
        receiver: 'Receiver'
      },
      backup: {
        sageIDDelivery: ''
      },
      showZoneModal: false,
      showDealerZoneModal: false,
      pendingAccounts: [],
      approvedAccounts: [],
      discountedZones: [],
      clientAccounts: {},
      isTransmiterZone: true,
      isReceiverZone: true,
      isBillingZone: true,
      autocompleteSearchFields: ['address_components', 'adr_address', 'formatted_address', 'formatted_phone_number', 'geometry', 'id', 'name', 'place_id', 'type', 'vicinity'],
      transmitterAddressData: null,
      transmitterPlaceResultData: null,
      receiverAddressData: null,
      receiverPlaceResultData: null,
      billingEvent: null,
      billingSection: null,
      billingLoading: false,
      logisticsEmailSource: '',
      identitySources: {
        payer: emptyIdentitySource(),
        transmitter: emptyIdentitySource(),
        receiver: emptyIdentitySource()
      },
      identityDefaults: {
        payer: false,
        transmitter: false,
        receiver: false
      },
      identityRequests: {
        payer: 0,
        transmitter: 0,
        receiver: 0
      },
      savedAddressbookPaths: {
        transmitter: '',
        receiver: ''
      }
      // 'utc_offset_minutes', 'url', 'photo', 'business_status', 'icon', 'scope', 'alt_id',
    }
  },

  async created () {
    if (this.order) {
      this.initialOrder = { ...this.order }
    }
    // this.$bindAsArray('sageone', db.ref('sageoneid/' + this.companyUID), null, () => {
    //       this.filteredSearchMethodSage()
    //     })
    // this.sage.key = this.order.sageID || ''
    try {
      await this.initialize()
    } finally {
      this.$emit('logistics-contact-ready')
    }
  },

  methods: {
    async initialize () {
      this.$bindAsArray('liste', db.ref('database/transporter/' + this.companyUID + '/liste'))
    this.$bindAsArray('pendingAccounts', db.ref('users/pending-creation').orderByChild('transporterUid').equalTo(this.companyUID), null, () => {
      this.approvedAccounts = this.pendingAccounts.filter(item => item.status === 'Approved' && item.lat && item.long)
      for (let item of this.approvedAccounts) {
        this.clientAccounts[`${item['.key']}`] = item.name
      }
      this.isLoading = false
    })
    if (this.order.payer) {
      this.datalist.billingUid = this.order.payer
    }

    if (this.order.transmitterContacts === '') {
      this.order.transmitterContacts = []
    }
    if (this.order.receiverContacts === '') {
      this.order.receiverContacts = []
    }
    if (!this.showBilling) {
      this.datalist.billingUid = this.order.payer
      if (this.datalist.billingUid) {
        await this.setSelectedDealer()
      }
    }
    await this.getDiscountedZones()
    await this.initializePendingOrderDetails()
    },

    // filteredSearchMethodSage: window._.debounce(function () {
    //     this.filterResultsSageOne = []
    //     this.filterResultsSageOne = this.sageone.filter((entry) => {
    //       var reg = this.sageOneNameFilter.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')
    //       var re = new RegExp(reg, 'i')
    //       var result = re.test(entry.A)
    //       return result
    //     })
    //   }, 100),
    resetBillingError () {
      this.isBillingZone = true
    },
    getCompanyFuelCharge () {
      const userInfo = this.$store.state.userInfo || {}
      return userInfo.fuelCharge !== undefined && userInfo.fuelCharge !== null && userInfo.fuelCharge !== ''
        ? userInfo.fuelCharge
        : 0
    },
    getClientFuelCharge (client) {
      return client && client.fuelCharge !== undefined && client.fuelCharge !== null && client.fuelCharge !== ''
        ? client.fuelCharge
        : this.getCompanyFuelCharge()
    },
    applyBillingAccountSettings (client) {
      if (!client) return
      if (client.contacts) {
        this.$set(this.order, 'payerContact', client.contacts)
      }
      if (client.sageID !== undefined) {
        this.$set(this.order, 'sageID', client.sageID || '')
      }
      this.$set(this.order, 'billingComment', client.billingComment || '')
      this.applyFuelChargeSettings(client)
    },
    cloneContacts (contacts) {
      if (!Array.isArray(contacts)) return []
      return contacts
        .filter(contact => contact && typeof contact === 'object')
        .map(contact => ({
          ...contact,
          dealerType: Array.isArray(contact.dealerType) ? contact.dealerType.slice() : contact.dealerType
        }))
    },
    contactsMatch (firstContacts, secondContacts) {
      const first = this.cloneContacts(firstContacts)
      const second = this.cloneContacts(secondContacts)
      return first.length > 0 && JSON.stringify(first) === JSON.stringify(second)
    },
    detectInitialLogisticsEmailSource (billingDealer) {
      if (!this.isModification || !billingDealer || billingDealer.allowDifferentLogisticsEmail !== true) return ''

      const payerContacts = this.order.payerContact
      if (this.contactsMatch(payerContacts, billingDealer.contacts)) return ''
      if (this.contactsMatch(payerContacts, this.order.transmitterContacts)) return 'pickup'
      if (this.contactsMatch(payerContacts, this.order.receiverContacts)) return 'delivery'
      return ''
    },
    hasUsableContactInfo (contacts) {
      return Array.isArray(contacts) && contacts.some(contact => {
        return contact && typeof contact === 'object' && String(contact.email || '').trim() !== ''
      })
    },
    logisticsContactsFor (source) {
      if (source === 'pickup') return this.order.transmitterContacts
      if (source === 'delivery') return this.order.receiverContacts
      return []
    },
    isLogisticsContactSourceInvalid (source) {
      return this.logisticsEmailSource === source && !this.hasUsableContactInfo(this.logisticsContactsFor(source))
    },
    selectLogisticsEmailSource (source, checked) {
      this.logisticsEmailSource = checked === true
        ? source
        : (this.logisticsEmailSource === source ? '' : this.logisticsEmailSource)
      this.syncLogisticsContactOverride()
    },
    syncLogisticsContactOverride () {
      const source = this.canChooseDifferentLogisticsEmail ? this.logisticsEmailSource : ''
      const isActive = source === 'pickup' || source === 'delivery'
      const hasSelectedDealer = this.selectedDealer &&
        typeof this.selectedDealer === 'object' &&
        Object.keys(this.selectedDealer).length > 0
      const contacts = isActive
        ? this.cloneContacts(this.logisticsContactsFor(source))
        : this.cloneContacts(hasSelectedDealer
          ? this.selectedDealer.contacts
          : (this.isModification ? this.order.payerContact : []))
      const isValid = !isActive || this.hasUsableContactInfo(contacts)

      this.$set(this.order, 'payerContact', contacts)
      this.$emit('logistics-contact-validation', {active: isActive, valid: isValid, source})
      return isValid
    },
    prepareLogisticsContactOverride () {
      return this.syncLogisticsContactOverride()
    },
    realNameOf (section) {
      return getRealName(this.order, section)
    },
    identityOf (section) {
      return getIdentityName(this.order, section)
    },
    setRealNameOf (section, name) {
      setRealName(this.order, section, name)
    },
    addressbookPath (key) {
      return `database/transporter/${this.companyUID}/addressbook/${key}`
    },
    resetIdentity (section) {
      clearIdentity(this.order, section)
      this.identityRequests[section]++
      this.identitySources[section] = emptyIdentitySource()
      this.identityDefaults[section] = false
    },
    /** @param applyDefault false when opening an existing order so the names already on it are kept */
    loadIdentitySource (section, path, record, applyDefault = true) {
      const current = this.identitySources[section]
      const alreadyChecked = current.path === path && current.defaultChecked
      const defaultIdentity = record && typeof record.defaultIdentity === 'string' ? record.defaultIdentity : ''
      this.identitySources[section] = {
        path,
        identities: normalizeIdentityList(record && record.identities),
        defaultIdentity,
        defaultChecked: true
      }
      if (alreadyChecked) return
      if (this.allowIdentities && applyDefault && defaultIdentity && !this.identityOf(section)) {
        setIdentity(this.order, section, defaultIdentity)
      }
      this.syncIdentityDefault(section)
    },
    async loadAddressbookIdentitySource (section, key, applyDefault = true) {
      if (!this.allowIdentities || !key) return false
      const request = ++this.identityRequests[section]
      const path = this.addressbookPath(key)
      try {
        const snapshot = await db.ref(path).once('value')
        if (request !== this.identityRequests[section] || !snapshot.exists()) return false
        this.loadIdentitySource(section, path, snapshot.val(), applyDefault)
        return true
      } catch (error) {
        console.error(error)
        return false
      }
    },
    /** Finds the addressbook entry of a pickup/delivery that wasn't picked from the addressbook (pending orders, modifications, Google search) */
    async resolveAddressbookIdentitySource (section, applyDefault = true) {
      if (!this.allowIdentities) return
      const realName = this.realNameOf(section)
      if (!realName) return
      const placeId = this.order[`${section}PlaceId`]
      if (placeId && await this.loadAddressbookIdentitySource(section, `${placeId}-_name_-${this.removeInvalidChars(realName)}`, applyDefault)) return
      if (this.realNameOf(section) !== realName) return
      const address = this.order[`${section}Address`]
      const entry = (this.addressbook || []).find(item => item.name === realName && item.address === address)
      if (entry) await this.loadAddressbookIdentitySource(section, entry.key, applyDefault)
    },
    onIdentityInput (section, name) {
      setIdentity(this.order, section, name)
      this.syncIdentityDefault(section)
    },
    syncIdentityDefault (section) {
      this.identityDefaults[section] = this.identityOf(section) === this.identitySources[section].defaultIdentity
    },
    canSaveIdentity (section) {
      if (this.identitySources[section].path) return true
      // Approving pending/marketplace orders doesn't save to the addressbook
      if (this.isPendingOrder || this.isFromMarketplace) return false
      if (section === 'transmitter') return this.pickupSave
      if (section === 'receiver') return this.deliverySave
      return false
    },
    showIdentityDefault (section) {
      return this.canSaveIdentity(section) && Boolean(this.identityOf(section) || this.identitySources[section].defaultIdentity)
    },
    /** Saves the names used on this order where the billing/pickup/delivery data is saved. Call after saveToAddressbook */
    saveIdentities () {
      if (!this.allowIdentities) return
      IDENTITY_SECTIONS.forEach(section => this.saveIdentity(section))
    },
    saveIdentity (section) {
      const source = this.identitySources[section]
      const paths = [...new Set([source.path, this.savedAddressbookPaths[section]].filter(Boolean))]
      if (!paths.length) return
      const identity = this.identityOf(section).trim()
      const updateDefault = this.showIdentityDefault(section)
      const isDefault = this.identityDefaults[section]
      paths.forEach(path => {
        const ref = db.ref(path)
        if (identity) {
          ref.child('identities').transaction(current => {
            const identities = normalizeIdentityList(current)
            return identities.includes(identity) ? identities : [...identities, identity]
          }).catch(error => console.error('Save identity error:', error))
        }
        if (!updateDefault) return
        if (isDefault) {
          ref.update({ defaultIdentity: identity || null })
        } else if (source.defaultIdentity && source.defaultIdentity === identity) {
          ref.update({ defaultIdentity: null })
        }
      })
    },
    applyFuelChargeSettings (client) {
      const applyFuelCharge = client && client.applyFuelCharge !== undefined ? client.applyFuelCharge : true

      this.$set(this.order, 'applyFuelCharge', applyFuelCharge)
      this.$set(this.order, 'includedFuelCharge', applyFuelCharge === false)
      this.$set(this.order, 'fuelCharge', this.getClientFuelCharge(client))
      this.$set(this.order, 'payerOdooPartnerId', client ? client.odooPartnerId || '' : '')
      this.$set(this.order, 'payerOdooPartnerName', client ? client.odooPartnerName || '' : '')
      this.$set(this.order, 'zeroTax', client && client.zeroTax === true)
      this.$emit('fuelChargeIncluded', applyFuelCharge === false)
    },
    onInputEntered: window._.debounce(function () {
      this.$emit('onVGAInput')
    }, 500),

    /** When email is checked/selected */
    onEmailSelected (selectedEmails) {
      this.$emit('sendSelectedEmails', selectedEmails)
    },

    /** When email is added to an email list
     * @var locFieldType: String indicating if the function call comes from transmitter or receiver
     */
    onEmailAdd (email) {
      if (!email) return
      if (!this.validateEmail(email)) {
        this.feedbackMessage = this.$t('NewOrder.email_invalid_format')
        return
      }

      this.feedbackMessage = ''
      if (typeof this.order.transmitterEmailList === 'undefined' || this.order.transmitterEmailList === '') this.order.transmitterEmailList = []
      this.order.transmitterEmailList.push(email)
      this.order.transmitterEmail = ''
    },

    /** Regex of javascript email
     * @link https://www.emailregex.com/ */
    validateEmail (email) {
      if (email.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) return true
      else return false
    },

    /** When email is removed from an email list */
    onEmailRemove (index) {
      this.order.transmitterEmailList.splice(index, 1)
      this.$forceUpdate()
    },

    vehiclePriceCheck (price) {
      return this.order.transmitterZone &&
           this.order.receiverZone &&
           (!price || price <= 0)
    },

    openModal () {
      if (this.isZoneBasedDiscount) {
        this.showDealerZoneModal = true
      } else {
        this.showZoneModal = true
      }
    },

    async closeModal () {
      if (this.isZoneBasedDiscount) {
        await this.getDiscountedZones()
        // this.calculatePrice()
        this.calculateTravelDistance()
        this.showDealerZoneModal = false
        return
      }
      this.getZones().then(() => this.calculatePrice())
      this.showZoneModal = false
    },

    closeAddDealerModal () {
      this.$bindAsArray('pendingAccounts', db.ref('users/pending-creation').orderByChild('transporterUid').equalTo(this.companyUID), null, () => {
        this.approvedAccounts = this.pendingAccounts.filter(item => item.status === 'Approved' && item.lat && item.long)
        for (let item of this.approvedAccounts) {
          this.clientAccounts[`${item['.key']}`] = item.name
        }
        this.isLoading = false
      })
      this.isAddDealer = false
    },

    updateContactList (newContactList) {
        this.order.transmitterContacts = newContactList
        this.syncLogisticsContactOverride()
    },

    updateReceiverContactList (newContactList) {
        this.order.receiverContacts = newContactList
        this.syncLogisticsContactOverride()
    },

    editReceiverContact (index) {
      this.receiverEditIndex = index
      this.isEditReceiverContact = true
    },

    editTransmitterContact (index) {
      this.transmitterEditIndex = index
      this.isEditTransmitterContact = true
    },

    deleteContact (index) {
        this.order.transmitterContacts.splice(index, 1)
        this.syncLogisticsContactOverride()
    },

    deleteReceiverContact (index) {
        this.order.receiverContacts.splice(index, 1)
        this.syncLogisticsContactOverride()
    },

    // Get all the zones saved under logged in transporterID (CompanyUID)
    async getZones () {
      if (!this.isZoneVerification) {
        return
      }
      if (!this.$store.state.zonesLoaded) {
        await this.$store.dispatch('subscribeToZones')
      }
      this.zones = this.$store.state.zones
    },

    async getDiscountedZones () {
      if (!this.isZoneVerification) {
        return
      }
      if (!this.order.payer) {
        this.discountedZones = []
        return
      }
      try {
        let snapshot = await db.ref(`users/dealers/${this.order.payer}/`).once('value')
        if (snapshot.exists()) {
          const billingDealer = snapshot.val()
          if (billingDealer.zones && billingDealer.discountType === 'Zone_Based_Discount') {
            this.discountedZones = Object.entries(billingDealer.zones).map(([id, zoneData]) => ({
              id,
              ...zoneData
            }))
          }
        }
      } catch (err) {
        console.error(err)
      }
    },

    searchZone (searchCoordinates) {
      if (!searchCoordinates.trim()) return null

      const [lat, lng] = searchCoordinates.split(',').map(coord => parseFloat(coord.trim()))
      if (isNaN(lat) || isNaN(lng)) return null

      const point = turfPoint([lng, lat])
      return this.findZoneByCoordinates(point)
    },

    noLogisticsContact () {
        const contactList = this.order.payerContact
        let isLogisticsContact = false

        contactList.forEach(contact => {
          if (contact.dealerType.includes('LOGISTICS')) {
            isLogisticsContact = true
          }
        })

        if (!isLogisticsContact) {
          return true
        }
        return false
    },

    findZoneByCoordinates (point) {
      if (!this.zones || !Array.isArray(this.zones) || this.zones.length === 0) {
        return null
      }
      return this.zones.find(zone => {
        try {
          if (!zone.coordinates || !Array.isArray(zone.coordinates) || zone.coordinates.length < 3) return false
          // Ensure coordinates form a closed polygon
          const coordinates = [...zone.coordinates]
          if (coordinates.length > 0) {
            const [firstCoord, lastCoord] = [coordinates[0], coordinates[coordinates.length - 1]]
            if (!firstCoord || !lastCoord || !Array.isArray(firstCoord) || !Array.isArray(lastCoord)) return false
            if (firstCoord[0] !== lastCoord[0] || firstCoord[1] !== lastCoord[1]) {
              coordinates.push(firstCoord)
            }
          }
          const polygon = turfPolygon([coordinates])
          return booleanPointInPolygon(point, polygon)
        } catch (e) {
          return false
        }
      })
    },

    async initializePendingOrderDetails () {
      await this.getZones()
      let latitude = 0
      let longitude = 0
      this.checkVGATransmitterInfo()
      this.checkVGAReceiverInfo()
      if (this.order.transmitterPlaceId || (this.order.transmitterLat && this.order.transmitterLong)) {
        latitude = this.order.transmitterLat
        longitude = this.order.transmitterLong

        let zone = this.searchZone(`${latitude},${longitude}`)
        this.$set(this.order, 'transmitterZone', zone ? zone.zoneName : '')
        this.$set(this.order, 'transmitterZoneId', zone ? zone.id : '')
        this.$emit('update:order.transmitterZoneId', this.order.transmitterZoneId)
      }

      // const currentPayer = await (await db.ref(`/users/pending-creation/${this.datalist.billingUid}`).once('value')).val()

      // this.$set(this.order, 'payerContact', Array.isArray(currentPayer.contacts) ? currentPayer.contacts : [])

      if (this.order.receiverPlaceId || (this.order.receiverLat && this.order.receiverLong)) {
        latitude = this.order.receiverLat
        longitude = this.order.receiverLong

        let zone = this.searchZone(`${latitude},${longitude}`)
        this.$set(this.order, 'receiverZone', zone ? zone.zoneName : '')
        this.$set(this.order, 'receiverZoneId', zone ? zone.id : '')
        this.$emit('update:order.receiverZoneId', this.order.receiverZoneId)
      }

      if (this.order.receiverZoneId && this.order.transmitterZoneId) {
        // this.calculatePrice()
        this.calculateTravelDistance()
      }

      if (this.allowIdentities) {
        this.resolveAddressbookIdentitySource('transmitter', this.isPendingOrder)
        this.resolveAddressbookIdentitySource('receiver', this.isPendingOrder)
      }

      if (this.order.payer) {
        try {
          const snap = await db.ref('users/dealers/').child(this.order.payer).once('value')
          if (!snap.exists()) return
          let selectedClient = snap.val()
          const initialLogisticsEmailSource = this.detectInitialLogisticsEmailSource(selectedClient)
          this.selectedDealer = selectedClient
          this.sage.key = this.order.sageID || ''
          this.applyBillingAccountSettings(selectedClient)
          this.loadIdentitySource('payer', `users/dealers/${this.order.payer}`, selectedClient, this.isPendingOrder)
          this.$emit('update:selectedDealer', selectedClient)
          this.logisticsEmailSource = initialLogisticsEmailSource
          this.syncLogisticsContactOverride()
          // this.sage.name = this.sageone.filter(sage => sage.B === this.order.sageID)[0].A
          await this.getZones()
          const payerZone = this.searchZone(`${selectedClient.lat},${selectedClient.long}`)
          this.$set(this.order, 'payerZone', payerZone ? payerZone.zoneName : '')
          this.$set(this.order, 'payerZoneId', payerZone ? payerZone.id : '')
        } catch (error) {
          console.error(error)
        }
      }
    },

    calculatePrice (index) {
      if (this.isFromDispatch) {
        return
      }
      if (!this.isFromMarketplace) {
        if (!this.order.transmitterZoneId || !this.order.receiverZoneId) {
          this.resetPriceAndZones()
          return
        }
        try {
          this.setZoneFlags()
          let regularPrice = this.getRegularPrice()
          this.transmitterZone = this.findTransmitterZone()
          this.order.regularPrice = regularPrice
          let { discountAmount, surplusAmount } = this.calculateDiscountAndSurplus(regularPrice)
          discountAmount = isNaN(discountAmount) ? 0 : discountAmount
          surplusAmount = isNaN(surplusAmount) ? 0 : surplusAmount
          this.order.price = ((Number(regularPrice) - discountAmount) + surplusAmount).toFixed(2)
          if (this.isPriceBasedDiscount) {
            this.applyPriceBasedDiscount(regularPrice, index)
          }
        } catch (err) {
          console.error('Error calculating price:', err)
          this.resetPriceAndZones()
        }
      }
    },

    resetPriceAndZones () {
      this.isTransmiterZone = !!this.order.transmitterZoneId
      this.isReceiverZone = !!this.order.receiverZoneId
      this.order.regularPrice = 0
      this.order.price = 0
    },

    setZoneFlags () {
      this.isTransmiterZone = !!this.order.transmitterZoneId
      this.isReceiverZone = !!this.order.receiverZoneId
    },

    getRegularPrice () {
      let transmitterId = this.order.transmitterZoneId
      let regularPrice = 0
      this.order.discount = 0
      this.order.surplus = 0

      if (this.isZoneBasedDiscount) {
        let discountedZone = this.discountedZones.find(zone => zone.id === transmitterId)
        if (discountedZone) {
          try {
            regularPrice = discountedZone[this.order.receiverZoneId].newPrice || 0
          } catch (err) {
            regularPrice = 0
          }
        }
      } else {
        try {
          let regularZone = this.zones.find(zone => zone.id === transmitterId)
          regularPrice = regularZone[this.order.receiverZoneId].price || 0
        } catch (err) {
          regularPrice = 0
        }
      }

      return regularPrice
    },

    findTransmitterZone () {
      let zone = null
      if (this.isZoneBasedDiscount) {
        zone = this.discountedZones.find(zone => zone.id === this.order.transmitterZoneId)
      }
      if (!zone || !this.isZoneBasedDiscount) {
        zone = this.zones.find(zone => zone.id === this.order.transmitterZoneId)
      }
      return zone
    },

    calculateDiscountAndSurplus (regularPrice) {
      let discountAmount = 0
      let surplusAmount = 0
      if (this.order.discountAmountType && this.order.discountAmountType === '$') {
        discountAmount = (Number(regularPrice) - Number(this.selectedDealer.discountAmount))
      } else {
        discountAmount = ((Number(regularPrice) * Number(this.order.discount)) / 100)
      }
      if (this.order.surplusAmountType && this.order.surplusAmountType === '$') {
        surplusAmount = (Number(regularPrice) + Number(this.selectedDealer.discountAmount))
      } else {
        surplusAmount = ((Number(regularPrice) * Number(this.order.surplus)) / 100)
      }
      return { discountAmount, surplusAmount }
    },

    applyPriceBasedDiscount (regularPrice) {
      const { discountAmountType, discountCategory, discountAmount } = this.selectedDealer
      if (discountAmountType === '$') {
        if (discountCategory === '-') {
          this.applyFixedDiscount(regularPrice, discountAmount)
        } else if (discountCategory === '+') {
          this.applyFixedSurplus(regularPrice, discountAmount)
        }
      } else if (discountAmountType === '%') {
        if (discountCategory === '-') {
          this.applyPercentageDiscount(regularPrice, discountAmount)
        } else if (discountCategory === '+') {
          this.applyPercentageSurplus(regularPrice, discountAmount)
        }
      }
    },

    applyFixedDiscount (regularPrice, discountAmount) {
      this.order.surplus = 0
      this.order.discount = Number(discountAmount)
      this.order.discountAmountType = '$'
      this.order.price = (Number(regularPrice) - this.order.discount).toFixed(2)
    },

    applyFixedSurplus (regularPrice, surplusAmount) {
      this.order.surplus = Number(surplusAmount)
      this.order.discount = 0
      this.order.surplusAmountType = '$'
      this.order.price = (Number(regularPrice) + this.order.surplus).toFixed(2)
    },

    applyPercentageDiscount (regularPrice, discountPercentage) {
      this.order.discount = discountPercentage
      this.order.surplus = 0
      this.order.discountAmountType = '%'
      let discountAmount = ((Number(regularPrice) * Number(discountPercentage)) / 100)
      this.order.price = (Number(regularPrice) - discountAmount).toFixed(2)
    },

    applyPercentageSurplus (regularPrice, surplusPercentage) {
      this.order.surplus = surplusPercentage
      this.order.discount = 0
      this.order.surplusAmountType = '%'
      let surplusAmount = ((Number(regularPrice) * Number(surplusPercentage)) / 100)
      this.order.price = (Number(regularPrice) + surplusAmount).toFixed(2)
    },

    async refreshBillingData () {
      if (this.billingEvent && this.billingSection) {
        await this.getZones()
        this.setAndSearch(this.billingEvent, this.billingSection, true)
      }
    },

    async refreshTranmitterData () {
      if (this.transmitterAddressData && this.transmitterPlaceResultData) {
        await this.getZones()
        this.onVGA_TRMTRSearch(this.transmitterAddressData, this.transmitterPlaceResultData, false)
      }
    },

    async refreshReceiverData () {
      if (this.receiverAddressData && this.receiverPlaceResultData) {
        await this.getZones()
        this.onVGA_RCVRSearch(this.receiverAddressData, this.receiverPlaceResultData, false)
      }
    },

    // TRANSMITTER TRANSMITTER TRANSMITTER TRANSMITTER TRANSMITTER TRANSMITTER TRANSMITTER
    /** On searching an address with Vue-Google-Autocomplete */
    async onVGA_TRMTRSearch (addressData, placeResultData, clearInfo = true) {
      clearInfo && this.clearTransmitterInfo() // Clean plate for search

      this.transmitterAddressData = addressData
      this.transmitterPlaceResultData = placeResultData

      const latitude = placeResultData.geometry.location.lat()
      const longitude = placeResultData.geometry.location.lng()

      const zone = this.searchZone(`${latitude},${longitude}`)

      const nameOfThisPlace = placeResultData.name
      let nameUsed = ''
      if (!nameOfThisPlace.includes(placeResultData.formatted_address.split(',')[0])) {
        nameUsed = placeResultData.name
      }

      setRealName(this.order, 'transmitter', nameUsed || this.realNameOf('transmitter') || '')
      this.order.transmitterAddress = placeResultData.formatted_address.split(',')[0] || this.order.transmitterAddress || ''
      this.order.transmitterPostcode = addressData.postal_code || this.order.transmitterPostcode || ''
      this.order.transmitterPhone = placeResultData.formatted_phone_number || this.order.transmitterPhone || ''
      this.order.transmitterCity = addressData.locality || this.order.transmitterCity || ''
      this.order.transmitterProvince = addressData.administrative_area_level_1 || ''
      this.order.transmitterCountry = addressData.country || this.order.transmitterCountry || ''
      this.order.transmitterPlaceId = placeResultData.place_id || ''
      this.order.transmitterLat = addressData.latitude || ''
      this.order.transmitterLong = addressData.longitude || ''
      this.order.latitude = addressData.latitude || ''
      this.order.longitude = addressData.longitude || ''
      this.$set(this.order, 'transmitterZone', zone ? zone.zoneName : '')
      this.$set(this.order, 'transmitterZoneId', zone ? zone.id : '')
      this.$emit('calculateZonePrice', this.order)
      this.$emit('update:order.transmitterZoneId', this.order.transmitterZoneId)
      this.order.transmitterContacts = this.order.transmitterContacts.length ? this.order.transmitterContacts : []
      // this.calculatePrice()
      this.calculateTravelDistance()
      clearInfo && this.checkVGATransmitterInfo() // Check for missing fields
      let addressBook = await this.getAddressbook(placeResultData.place_id)
      this.arrOfTransmitterPlaces = this.getCommonPlaces(addressBook, placeResultData.place_id)
      if (clearInfo) this.resolveAddressbookIdentitySource('transmitter')
    },

    /** Clear transmitter related data before The Big Bang */
    clearTransmitterInfo () {
      this.resetIdentity('transmitter')
      this.datalist.pickup = ''
      this.datalist.pickupUid = ''
      this.order.transmitterName = ''
      this.order.transmitterAddress = ''
      this.order.transmitterPostcode = ''
      this.order.transmitterPhone = ''
      this.order.transmitterFax = ''
      this.order.transmitterContact = ''
      this.order.transmitterCity = ''
      this.order.transmitterProvince = ''
      this.order.transmitterCountry = ''
      this.order.transmitterPlaceId = ''
      this.order.transmitterLat = 0
      this.order.transmitterLong = 0
      this.order.transmitterEmailList = []
      this.order.transmitterContacts = []
      this.order.transmitterZone = ''
      this.order.transmitterZoneId = ''
    },

    /** Sometimes VGA addresses have missing data.
     * This is to allow users to fill in info themselves if there are missing info.
     */
    checkVGATransmitterInfo () {
      if (this.order.transmitterAddress !== '') this.isTransmitterInfo.address = true
      else this.isTransmitterInfo.address = false

      if (this.order.transmitterPostcode !== '') this.isTransmitterInfo.postcode = true
      else this.isTransmitterInfo.postcode = false

      if (this.order.transmitterCity !== '') this.isTransmitterInfo.city = true
      else this.isTransmitterInfo.city = false

      if (this.order.transmitterProvince !== '') this.isTransmitterInfo.province = true
      else this.isTransmitterInfo.province = false

      if (this.order.transmitterCountry !== '') this.isTransmitterInfo.country = true
      else this.isTransmitterInfo.country = false
    },

    /** Set the transmitter info from the @company that is given */
    async setTransmitterInfo (company, addressbookKey = '') {
      this.resetIdentity('transmitter')
      if (company.emailList) this.order.transmitterEmailList = company.emailList
      else this.order.transmitterEmailList = []

      if (company.lat !== undefined && company.long !== undefined) {
        if (this.isZoneVerification && this.zones.length === 0) {
          await this.getZones()
        }
        this.pickupZone = this.searchZone(`${company.lat},${company.long}`)
      }

      this.order.transmitterName = company.name
      this.order.transmitterAddress = company.address
      this.order.transmitterPostcode = company.postcode
      this.order.transmitterCity = company.city
      this.order.transmitterProvince = company.province
      this.order.transmitterCountry = company.country
      this.order.transmitterPhone = company.phone
      this.order.transmitterFax = company.fax
      this.order.transmitterContact = company.contact
      this.order.transmitterPlaceId = company.placeId !== undefined ? company.placeId : this.order.transmitterPlaceId
      this.order.transmitterLat = company.lat !== undefined ? company.lat : this.order.transmitterLat
      this.order.transmitterLong = company.long !== undefined ? company.long : this.order.transmitterLong
      this.order.latitude = this.order.transmitterLat
      this.order.longitude = this.order.transmitterLong
      this.$set(this.order, 'transmitterZone', this.pickupZone ? this.pickupZone.zoneName : '' || this.order.transmitterZone)
      this.$set(this.order, 'transmitterZoneId', this.pickupZone ? this.pickupZone.id : '' || this.order.transmitterZoneId)
      this.$emit('update:order.transmitterZoneId', this.order.transmitterZoneId)
      this.$emit('calculateZonePrice', this.order)
      this.order.transmitterContacts = []
      // this.calculatePrice()
      this.calculateTravelDistance()
      this.loadAddressbookIdentitySource('transmitter', addressbookKey)
    },

    // RECEIVER RECEIVER RECEIVER RECEIVER RECEIVER
    async onVGA_RCVRSearch (addressData, placeResultData, clearInfo = true) {
      clearInfo && this.clearReceiverInfo()

      this.receiverAddressData = addressData
      this.receiverPlaceResultData = placeResultData

      const nameOfThisPlace = placeResultData.name
      let nameUsed = ''
      if (!nameOfThisPlace.includes(placeResultData.formatted_address.split(',')[0])) {
        nameUsed = placeResultData.name
      }

      const latitude = placeResultData.geometry.location.lat()
      const longitude = placeResultData.geometry.location.lng()

      const zone = this.searchZone(`${latitude},${longitude}`)

      setRealName(this.order, 'receiver', nameUsed || this.realNameOf('receiver') || '')
      this.order.receiverAddress = placeResultData.formatted_address.split(',')[0] || this.order.receiverAddress || ''
      this.order.receiverPostcode = addressData.postal_code || this.order.receiverPostcode || ''
      this.order.receiverPhone = placeResultData.formatted_phone_number || this.order.receiverPhone || ''
      this.order.receiverCity = addressData.locality || this.order.receiverCity || ''
      this.order.receiverProvince = addressData.administrative_area_level_1 || this.order.receiverProvince || ''
      this.order.receiverCountry = addressData.country || this.order.receiverCountry || ''
      this.order.receiverPlaceId = placeResultData.place_id || ''
      this.order.receiverLat = addressData.latitude || ''
      this.order.receiverLong = addressData.longitude || ''
      this.$set(this.order, 'receiverZone', zone ? zone.zoneName : '')
      this.$set(this.order, 'receiverZoneId', zone ? zone.id : '')
      this.$emit('calculateZonePrice', this.order)
      this.$emit('update:order.receiverZoneId', this.order.receiverZoneId)

      this.order.receiverContacts = this.order.receiverContacts.length ? this.order.receiverContacts : []
      // this.calculatePrice()
      this.calculateTravelDistance()

      clearInfo && this.checkVGAReceiverInfo()
      let addressBook = await this.getAddressbook(placeResultData.place_id)
      this.arrOfReceiverPlaces = this.getCommonPlaces(addressBook, placeResultData.place_id)
      if (clearInfo) this.resolveAddressbookIdentitySource('receiver')
    },

    clearReceiverInfo () {
      this.resetIdentity('receiver')
      this.datalist.delivery = ''
      this.datalist.deliveryUid = ''
      this.order.receiverName = ''
      this.order.receiverAddress = ''
      this.order.receiverPostcode = ''
      this.order.receiverPhone = ''
      this.order.receiverFax = ''
      this.order.receiverContact = ''
      this.order.receiverCity = ''
      this.order.receiverProvince = ''
      this.order.receiverCountry = ''
      this.order.receiverPlaceId = ''
      this.order.receiverLat = 0
      this.order.receiverLong = 0
      this.order.receiverEmailList = []
      this.order.receiverContacts = []
      this.order.receiverZone = ''
      this.order.receiverZoneId = ''
    },

    checkVGAReceiverInfo () {
      if (this.order.receiverAddress !== '') this.isReceiverInfo.address = true
      else this.isReceiverInfo.address = false

      if (this.order.receiverPostcode !== '') this.isReceiverInfo.postcode = true
      else this.isReceiverInfo.postcode = false

      if (this.order.receiverCity !== '') this.isReceiverInfo.city = true
      else this.isReceiverInfo.city = false

      if (this.order.receiverProvince !== '') this.isReceiverInfo.province = true
      else this.isReceiverInfo.province = false

      if (this.order.receiverCountry !== '') this.isReceiverInfo.country = true
      else this.isReceiverInfo.country = false
    },

    async setReceiverInfo (company, addressbookKey = '') {
      this.resetIdentity('receiver')
      if (company.lat !== undefined && company.long !== undefined) {
        if (this.isZoneVerification && this.zones.length === 0) {
          await this.getZones()
        }
        this.dropZone = this.searchZone(`${company.lat},${company.long}`)
      }

      this.order.receiverAddress = company.address
      this.order.receiverPostcode = company.postcode
      this.order.receiverCity = company.city
      this.order.receiverProvince = company.province
      this.order.receiverCountry = company.country
      this.order.receiverName = company.name
      this.order.receiverPhone = company.phone
      this.order.receiverFax = company.fax
      this.order.receiverContact = company.contact
      this.order.receiverPlaceId = company.placeId !== undefined ? company.placeId : this.order.receiverPlaceId
      this.order.receiverLat = company.lat !== undefined ? company.lat : this.order.receiverLat
      this.order.receiverLong = company.long !== undefined ? company.long : this.order.receiverLong
      this.$set(this.order, 'receiverZone', this.dropZone ? this.dropZone.zoneName : '' || this.order.receiverZone)
      this.$set(this.order, 'receiverZoneId', this.dropZone ? this.dropZone.id : '' || this.order.receiverZoneId)
      this.$emit('calculateZonePrice', this.order)
      this.$emit('update:order.receiverZoneId', this.order.receiverZoneId)
      this.order.receiverContacts = []
      // this.calculatePrice()
      this.calculateTravelDistance()
      this.loadAddressbookIdentitySource('receiver', addressbookKey)
    },
    // Receiver End

    /** Save addresses to the addressbook */
    saveToAddressbook (order) {
      const addressbookRef = db.ref('database/transporter/' + this.companyUID + '/addressbook')
      this.savedAddressbookPaths = { transmitter: '', receiver: '' }

      if (this.pickupSave) {
        const transmitterName = getRealName(order, 'transmitter')
        var savedPickup = {
          'address': order.transmitterAddress,
          'city': order.transmitterCity,
          'contact': order.transmitterContact,
          'fax': order.transmitterFax,
          'name': transmitterName,
          // 'receptionEmail': order.transmitterEmail,
          // 'emailList': order.transmitterEmailList || [],
          'contacts': order.transmitterContacts || [],
          'postcode': order.transmitterPostcode,
          'country': order.transmitterCountry,
          'province': order.transmitterProvince,
          'phone': order.transmitterPhone,
          'placeId': order.transmitterPlaceId,
          'lat': order.transmitterLat,
          'long': order.transmitterLong,
          'zone': order.transmitterZone || '',
          'zoneId': order.transmitterZoneId
        }

        // update() keeps the identities saved on the entry
        const pickupRef = order.transmitterPlaceId
          ? addressbookRef.child(order.transmitterPlaceId + '-_name_-' + this.removeInvalidChars(transmitterName))
          : addressbookRef.push()
        order.transmitterPlaceId ? pickupRef.update(savedPickup) : pickupRef.set(savedPickup)
        this.savedAddressbookPaths.transmitter = this.addressbookPath(pickupRef.key)
      }

      if (this.deliverySave) {
        const receiverName = getRealName(order, 'receiver')
        var savedDelivery = {
          'address': order.receiverAddress,
          'city': order.receiverCity,
          'contact': order.receiverContact,
          'fax': order.receiverFax,
          'name': receiverName,
          // 'receptionEmail': order.receiverEmail,
          // 'emailList': [],
          'contacts': order.receiverContacts || [],
          'postcode': order.receiverPostcode,
          'country': order.receiverCountry,
          'province': order.receiverProvince,
          'phone': order.receiverPhone,
          'placeId': order.receiverPlaceId,
          'lat': order.receiverLat,
          'long': order.receiverLong,
          'zone': order.receiverZone || '',
          'zoneId': order.receiverZoneId
        }

        const deliveryRef = order.receiverPlaceId
          ? addressbookRef.child(order.receiverPlaceId + '-_name_-' + this.removeInvalidChars(receiverName))
          : addressbookRef.push()
        order.receiverPlaceId ? deliveryRef.update(savedDelivery) : deliveryRef.set(savedDelivery)
        this.savedAddressbookPaths.receiver = this.addressbookPath(deliveryRef.key)
      }
    },

    removeInvalidChars (text) {
      text = text.replace('.', '')
      text = text.replace('$', '')
      text = text.replace('#', '')
      text = text.replace('[', '')
      text = text.replace(']', '')
      text = text.replace('/', '')
      return text
    },

    /** Finds the company in the appropriate list and then sets the info */
    onCompanyNameSelect (companyName, locType) {
      if (!companyName) return

      if (locType === this.baseStr.transmitter) {
        let company = this.arrOfTransmitterPlaces.find(company => company.info.name === companyName)
        this.setTransmitterInfo(company.info, company.key)
      } else if (locType === this.baseStr.receiver) {
        let company = this.arrOfReceiverPlaces.find(company => company.info.name === companyName)
        this.setReceiverInfo(company.info, company.key)
      }
    },

    /**
     * @param placeId: Google-generated-string that is used to locate a specific place, some places may sometime be missing information
     *  */
    async getAddressbook (placeId) {
      if (!placeId) return
      let addressBook = {}

      await db.ref('database')
      .child('transporter')
      .child(this.companyUID)
      .child('addressbook')
      .once('value').then((snap) => {
        addressBook = snap.val()
      })

      return addressBook
    },

    /** From the addressbook, get the list of name of companies that have the same @placeId */
    getCommonPlaces (addressBook, placeId) {
      let arrCommonPlaces = []

      for (const key in addressBook) {
        if (Object.hasOwnProperty.call(addressBook, key)) {
          const place = addressBook[key]

          let placeSplit = key.split('-_name_-')
          if (placeSplit[0] === placeId) {
            arrCommonPlaces.push({
              info: place,
              name: place.name,
              key
            })
          }
        }
      }

      return arrCommonPlaces
    },

    async setSelectedDealer () {
      try {
        let snapshot = await db.ref(`users/dealers/${this.datalist.billingUid}/`).once('value')
        if (snapshot.exists()) {
          this.selectedDealer = snapshot.val()
          if (this.selectedDealer.zones && this.isZoneBasedDiscount) {
              this.discountedZones = Object.entries(this.selectedDealer.zones).map(([id, zoneData]) => ({
                id,
                ...zoneData
              }))
          }
          this.applyBillingAccountSettings(this.selectedDealer)
          this.$emit('update:selectedDealer', this.selectedDealer)
          // this.calculatePrice()
        }
      } catch (err) {
        console.error(err)
      }
    },

    /** @param keepIdentity true when the same billing account is reloaded (e.g. after defining a zone) */
    async setAndSearch (event, section, keepIdentity = false) {
      if (section === 'pickup') {
        this.$refs.AutocompleteSearchPickup.clear()
        this.resetIdentity('transmitter')

        this.datalist.pickup = event.value
        this.datalist.pickupUid = event.key
        this.order.transmitterContacts = []
        if (event.key !== null) {
          if (this.isZoneVerification && this.zones.length === 0) {
            await this.getZones()
          }
          db.ref('users/dealersList/').child(this.datalist.pickupUid).once('value').then((snap) => {
            if (snap.val()) {
              this.pickupZone = this.searchZone(`${snap.val().lat}, ${snap.val().long}`)
              setRealName(this.order, 'transmitter', snap.val().name)
              this.order.transmitterAddress = snap.val().address
              this.order.transmitterCity = snap.val().city
              this.order.transmitterPostcode = snap.val().postcode
              this.order.transmitterPhone = snap.val().phone
              this.order.transmitterEmail = snap.val().receptionEmail || ''
              this.order.transmitterFax = snap.val().fax
              this.order.transmitterProvince = snap.val().province
              this.order.transmitterCountry = snap.val().country
              this.order.transmitterPlaceId = snap.val().placeId
              this.order.transmitterLat = snap.val().lat
              this.order.transmitterLong = snap.val().long
              this.order.latitude = this.order.transmitterLat
              this.order.longitude = this.order.transmitterLong
              this.$set(this.order, 'transmitterZone', this.pickupZone ? this.pickupZone.zoneName : '')
              this.$set(this.order, 'transmitterZoneId', this.pickupZone ? this.pickupZone.id : '')
              this.$emit('calculateZonePrice', this.order)
              this.$emit('update:order.transmitterZoneId', this.order.transmitterZoneId)
            }
            // this.order.transmitterContact = snap.val().contact
          }).catch(function (error) {
            console.error(error)
          })
          this.addressbook.forEach((entry) => {
            if (entry['key'] === this.datalist.pickupUid) {
              this.pickupZone = this.searchZone(`${entry.lat}, ${entry.long}`)
              this.order.transmitterName = entry.name
              this.order.transmitterAddress = entry.address
              this.order.transmitterCity = entry.city
              this.order.transmitterPostcode = entry.postcode
              this.order.transmitterPhone = entry.phone
              this.order.transmitterEmail = entry.receptionEmail || ''
              this.order.transmitterEmailList = entry.emailList || []
              this.order.transmitterContacts = entry.contacts || []
              this.order.transmitterFax = entry.fax
              this.order.transmitterProvince = entry.province
              this.order.transmitterCountry = entry.country
              this.order.transmitterPlaceId = entry.placeId || entry.place_id
              this.order.transmitterLat = entry.lat
              this.order.transmitterLong = entry.long
              this.order.latitude = this.order.transmitterLat
              this.order.longitude = this.order.transmitterLong
              this.$set(this.order, 'transmitterZone', this.pickupZone ? this.pickupZone.zoneName : '')
              this.$set(this.order, 'transmitterZoneId', this.pickupZone ? this.pickupZone.id : '')
              this.$emit('calculateZonePrice', this.order)
              this.$emit('update:order.transmitterZoneId', this.order.transmitterZoneId)
              // this.calculatePrice()
              this.calculateTravelDistance()
              this.loadAddressbookIdentitySource('transmitter', entry.key)
            }
          })
        }
      }

      if (section === 'delivery') {
        this.$refs.AutocompleteSearchDelivery.clear()
        this.resetIdentity('receiver')
        this.datalist.delivery = event.value
        this.datalist.deliveryUid = event.key
        this.order.receiverContacts = []
        if (event.key !== null) {
          if (this.isZoneVerification && this.zones.length === 0) {
            await this.getZones()
          }
          db.ref('users/dealersList/').child(this.datalist.deliveryUid).once('value').then((snap) => {
            if (snap.val()) {
              this.dropZone = this.searchZone(`${snap.val().lat}, ${snap.val().long}`)
              setRealName(this.order, 'receiver', snap.val().name)
              this.order.receiverAddress = snap.val().address
              this.order.receiverCity = snap.val().city
              this.order.receiverPostcode = snap.val().postcode
              this.order.receiverPhone = snap.val().phone
              this.order.receiverEmail = snap.val().receptionEmail || ''
              this.order.receiverFax = snap.val().fax
              this.order.receiverProvince = snap.val().province
              this.order.receiverCountry = snap.val().country
              this.order.receiverPlaceId = snap.val().placeId
              this.order.receiverLat = snap.val().lat
              this.order.receiverLong = snap.val().long
              this.$set(this.order, 'receiverZone', this.dropZone ? this.dropZone.zoneName : '')
              this.$set(this.order, 'receiverZoneId', this.dropZone ? this.dropZone.id : '')
              this.$emit('calculateZonePrice', this.order)
              this.$emit('update:order.receiverZoneId', this.order.receiverZoneId)
              if (this.billingSame) this.order.sageID = snap.val().sageID
              this.backup.sageIDDelivery = snap.val().sageID
              this.onInputBillingSame()
            }
            // this.order.transmitterContact = snap.val().contact
          }).catch(function (error) {
            console.error(error)
          })
          this.addressbook.forEach((entry) => {
            if (entry['key'] === this.datalist.deliveryUid) {
              this.dropZone = this.searchZone(`${entry.lat}, ${entry.long}`)
              this.order.receiverName = entry.name
              this.order.receiverAddress = entry.address
              this.order.receiverCity = entry.city
              this.order.receiverPostcode = entry.postcode
              this.order.receiverPhone = entry.phone
              this.order.receiverEmail = entry.receptionEmail || ''
              this.order.receiverContacts = entry.contacts || []
              this.order.receiverFax = entry.fax
              this.order.receiverProvince = entry.province
              this.order.receiverCountry = entry.country
              this.order.receiverPlaceId = entry.placeId || entry.place_id
              this.order.receiverLat = entry.lat
              this.order.receiverLong = entry.long
              this.$set(this.order, 'receiverZone', this.dropZone ? this.dropZone.zoneName : '')
              this.$set(this.order, 'receiverZoneId', this.dropZone ? this.dropZone.id : '')
              this.$emit('calculateZonePrice', this.order)
              this.$emit('update:order.receiverZoneId', this.order.receiverZoneId)
              // this.calculatePrice()
              this.calculateTravelDistance()
              if (this.billingSame) this.order.sageID = entry.sageID
              this.backup.sageIDDelivery = entry.sageID
              this.onInputBillingSame()
              this.loadAddressbookIdentitySource('receiver', entry.key)
            }
          })
        }
      }

      if (section === 'billing') {
        if (this.billingLoading) {
          return
        }
        if (this.datalist.billingUid !== event.key) {
          this.logisticsEmailSource = ''
        }
        if (!keepIdentity) this.resetIdentity('payer')
        this.billingEvent = event
        this.billingSection = section
        this.datalist.billing = event.value
        this.datalist.billingUid = event.key
        if (event.key !== null) {
          this.billingLoading = true
          db.ref('users/dealers/').child(this.datalist.billingUid).once('value').then(async (snap) => {
            if (!snap.exists()) {
              this.billingLoading = false
              return
            }
            let selectedClient = snap.val()
            this.selectedDealer = selectedClient
            if (selectedClient.contacts) {
              this.order.payerContact = selectedClient.contacts
            }
             await this.getZones()
             const payerZone = this.searchZone(`${selectedClient.lat},${selectedClient.long}`)
              setRealName(this.order, 'payer', selectedClient.name)
              this.order.payerAddress = selectedClient.address
              this.order.payerCity = selectedClient.city
              this.order.payerPostcode = selectedClient.postcode
              this.order.payerPhone = selectedClient.phone
              this.order.payerEmail = selectedClient.email || ''
              this.order.payerFax = selectedClient.fax
              this.order.payerProvince = selectedClient.province
              this.order.billingComment = selectedClient.billingComment
              this.order.payerCountry = selectedClient.country
              this.applyFuelChargeSettings(selectedClient)
              this.$set(this.order, 'billingComment', selectedClient.billingComment || '')
              this.$set(this.order, 'payerZone', payerZone ? payerZone.zoneName : '')
              this.$set(this.order, 'payerZoneId', payerZone ? payerZone.id : '')
              this.order.payer = this.datalist.billingUid
              this.loadIdentitySource('payer', `users/dealers/${this.datalist.billingUid}`, selectedClient, !keepIdentity)
              this.isBillingZone = this.order.payerZoneId
              this.order.sageID = selectedClient.sageID
              this.$emit('update:selectedDealer', selectedClient)
              this.billingLoading = false
              // this.calculatePrice()
              // this.calculateTravelDistance()
          }).catch((error) => {
            console.error(error)
            this.billingLoading = false
          })
          this.addressbook.forEach((entry) => {
            if (entry['key'] === this.datalist.billingUid) {
              setRealName(this.order, 'payer', entry.name)
              this.order.payerAddress = entry.address
              this.order.payerCity = entry.city
              this.order.payerPostcode = entry.postcode
              this.order.payerPhone = entry.phone
              this.order.payerEmail = entry.receptionEmail || ''
              this.order.payerFax = entry.fax
              this.order.payerProvince = entry.province
              this.order.payerCountry = entry.country
              this.order.sageID = entry.sageID
              this.applyFuelChargeSettings(entry)
              this.$set(this.order, 'billingComment', entry.billingComment || '')
              this.$emit('update:selectedDealer', entry)
              // this.calculatePrice()
              this.calculateTravelDistance()
            }
          })
        }
      }
    },

    // Button: Same as pickup
    // Copies pickup info as billing info
    onInputBillingSame: function () {
      if (this.billingSame) {
        this.order.payerAddress = this.order.receiverAddress
        this.order.payerCity = this.order.receiverCity
        this.order.payerContact = this.order.receiverContact
        this.order.payerFax = this.order.receiverFax
        this.order.payerName = this.order.receiverName
        this.order.payerPhone = this.order.receiverPhone
        this.order.payerEmail = this.order.receiverEmail
        this.order.payerPostcode = this.order.receiverPostcode
        this.order.payerProvince = this.order.receiverProvince
        this.order.payerCountry = this.order.receiverCountry
      }
    },

    calculateTravelDistance () {
      const originLat = this.order.transmitterLat
      const originLng = this.order.transmitterLong
      const destLat = this.order.receiverLat
      const destLng = this.order.receiverLong
      const mode = 'DRIVING'
      let google = this.google
      if (!google) return
      if (!originLat || !originLng || !destLat || !destLng) return
      return new Promise((resolve, reject) => {
        const directionsService = new google.maps.DirectionsService()

        const origin = new google.maps.LatLng(originLat, originLng)
        const destination = new google.maps.LatLng(destLat, destLng)

        const request = {
          origin: origin,
          destination: destination,
          travelMode: google.maps.TravelMode[mode]
        }

        directionsService.route(request, (result, status) => {
          if (status === google.maps.DirectionsStatus.OK) {
            const route = result.routes[0]
            let totalDistance = 0

            for (let i = 0; i < route.legs.length; i++) {
              totalDistance += route.legs[i].distance.value
            }
            // Convert distance from meters to kilometers
            const distanceInKm = totalDistance / 1000
            this.order.distance = distanceInKm
            resolve(distanceInKm)
          } else {
            reject('Unable to calculate travel distance')
          }
        })
      })
    },

    onResize: window._.debounce(function () {
      this.isScreenSmall = window.innerWidth < 600
    }, 50)
  },

  async mounted () {
    this.onResize()
    window.addEventListener('resize', this.onResize, { passive: true })
    await this.getZones()
  },

  beforeDestroy () {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, { passive: true })
    }
  },

  computed: {
    google: gmapApi,
    companyUID () {
      return this.$store.state.authorization.company
    },
    sageIDonly () {
      return this.addressbook.filter(customer => customer.sageID)
    },
    sageOneCheck () {
      return ((this.$store.state.userInfo.isSageOne && this.order.sageID !== '' && this.order.sageID !== undefined) || !this.$store.state.userInfo.isSageOne)
    },

    isSageOne () {
      return this.$store.state.userInfo.isSageOne
    },

    isBilling () {
      return !!this.datalist.billingUid && !!this.order.payerCountry
    },

    canChooseDifferentLogisticsEmail () {
      return !this.isPendingOrder &&
        !this.isFromMarketplace &&
        Boolean(this.order && this.order.payer) &&
        Boolean(this.selectedDealer && this.selectedDealer.allowDifferentLogisticsEmail === true)
    },

    showPickupLogisticsEmailOption () {
      return this.canChooseDifferentLogisticsEmail && Boolean(
        this.datalist.pickupUid || (this.isModification && this.order.transmitterName)
      )
    },

    showDeliveryLogisticsEmailOption () {
      return this.canChooseDifferentLogisticsEmail && Boolean(
        this.datalist.deliveryUid || (this.isModification && this.order.receiverName)
      )
    },

    isZoneBasedDiscount () {
      return this.selectedDealer && this.selectedDealer.discountType === 'Zone_Based_Discount'
    },

    isPriceBasedDiscount () {
      return this.selectedDealer && this.selectedDealer.discountType === 'Price_Based_Discount'
    },

    isZoneVerification () {
      return this.$store.state.userInfo.isZoneVerification || false
    },
    checkReceiverZone () {
      return this.order.receiverPlaceId && !this.order.receiverZoneId
    },
    checkTransmitterZone () {
      return this.order.transmitterPlaceId && !this.order.transmitterZoneId
    },
    getReceiverZone () {
      return this.order.receiverZone
    },

    getTransmitterZone () {
      return this.order.transmitterZone
    },

    getPayerZone () {
      return this.order.payerZone
    },

    formCompleted: function () {
      var order = this.order
      return (
        // this.vehicles.length !== 0 &&
        order.receiverName !== '' &&
        order.receiverAddress !== '' &&
        order.receiverCountry !== '' &&
        order.receiverCity !== '' &&
        order.receiverPostcode !== '' &&
        order.receiverProvince !== '' &&
        order.payerName !== '' &&
        order.payerAddress !== '' &&
        order.payerCountry !== '' &&
        order.payerCity !== '' &&
        order.payerPostcode !== '' &&
        order.payerProvince !== '' &&
        order.transmitterName !== '' &&
        order.transmitterAddress !== '' &&
        order.transmitterCountry !== '' &&
        order.transmitterCity !== '' &&
        order.transmitterPostcode !== '' &&
        order.transmitterProvince !== '' &&
        order.transmitterZone !== '' &&
        order.receiverZone !== ''
    )
        // ((this.isSageOne && order.price !== '') || !this.isSageOne))
    }
  },

  watch: {
    selectedDealer (dealer) {
      if (!dealer || dealer.allowDifferentLogisticsEmail !== true) {
        this.logisticsEmailSource = ''
      }
      this.syncLogisticsContactOverride()
    },
    'datalist.pickupUid' (dealerId) {
      if (!dealerId && this.logisticsEmailSource === 'pickup') {
        this.logisticsEmailSource = ''
        this.syncLogisticsContactOverride()
      }
    },
    'datalist.deliveryUid' (dealerId) {
      if (!dealerId && this.logisticsEmailSource === 'delivery') {
        this.logisticsEmailSource = ''
        this.syncLogisticsContactOverride()
      }
    },
    'order.transmitterContacts': {
      handler () {
        if (this.logisticsEmailSource === 'pickup') this.syncLogisticsContactOverride()
      },
      deep: true
    },
    'order.receiverContacts': {
      handler () {
        if (this.logisticsEmailSource === 'delivery') this.syncLogisticsContactOverride()
      },
      deep: true
    },
    billingSame: function (val) {
      var order = this.order
      if (!val) {
        order.payerAddress = ''
        order.payerCity = ''
        order.payerContact = ''
        order.payerFax = ''
        order.payerName = ''
        order.payerPhone = ''
        order.payerEmail = ''
        order.payerPostcode = ''
        order.payerProvince = ''
        order.payerCountry = ''
        order.sageID = ''
      } else {
        order.payerAddress = order.receiverAddress
        order.payerCity = order.receiverCity
        order.payerContact = order.receiverContact
        order.payerFax = order.receiverFax
        order.payerName = order.receiverName
        order.payerPhone = order.receiverPhone
        order.payerEmail = order.receiverEmail
        order.payerPostcode = order.receiverPostcode
        order.payerProvince = order.receiverProvince
        order.payerCountry = order.receiverCountry
        order.sageID = this.backup.sageIDDelivery || ''
        this.datalist.billing = ''
        this.datalist.billingUid = ''
      }
    },

    async 'order.transmitterPlaceId' (newVal, oldVal) {
      if (newVal !== oldVal) {
        if (this.isZoneVerification && this.zones.length === 0) {
          await this.getZones()
        }
        let zone = this.searchZone(`${this.order.transmitterLat},${this.order.transmitterLong}`)
        this.$set(this.order, 'transmitterZone', zone ? zone.zoneName : '')
        this.$set(this.order, 'transmitterZoneId', zone ? zone.id : '')

        this.$emit('update:order.transmitterZoneId', this.order.transmitterZoneId)
      }
    },

    async 'order.receiverPlaceId' (newVal, oldVal) {
      if (newVal !== oldVal) {
        if (this.isZoneVerification && this.zones.length === 0) {
          await this.getZones()
        }
        let zone = this.searchZone(`${this.order.receiverLat},${this.order.receiverLong}`)
        this.$set(this.order, 'receiverZone', zone ? zone.zoneName : '')
        this.$set(this.order, 'receiverZoneId', zone ? zone.id : '')

        this.$emit('update:order.receiverZoneId', this.order.receiverZoneId)
      }
    }
  }
}
</script>

<style scoped>
.contact-display {
  display: flex;
  justify-content: space-between;
}

.orderInfoContainer {
  display: flex;
  width: 100%;
  flex-direction: row;
  flex-wrap: wrap;
}

.orderColumn {
  flex: 1 1 30%; /* For three columns */
  min-width: 250px;
  margin-bottom: 20px; /* Add some space between columns when they wrap */
}

/* When only two columns are shown */
.orderInfoContainer--TwoColumns .orderColumn {
  flex: 1 1 50%; /* Make each column take up 50% width */
  max-width: 48%; /* Ensure it doesn't grow beyond 50% */
}

.new-dealer {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-weight: 600;
}

.billing-datalist {
  flex: 1 1 95%;
  min-width: 0;
}

.billing-comment-box {
  background-color: #fff3cd;
  border: 1px solid #ffc107;
  border-radius: 8px;
  padding: 12px;
}

.billing-comment-header {
  font-weight: 600;
  color: #856404;
  margin-bottom: 8px;
  font-size: 14px;
}

.billing-comment-content {
  color: #856404;
  font-size: 14px;
  white-space: pre-wrap;
}

/* Mobile styles */
.orderInfoContainer--Mobile {
  display: flex;
  flex-direction: column !important;
  flex-wrap: nowrap;
  width: 100% !important; 
  margin-inline: 10px;
}


.orderInfoContainer--Mobile .orderColumn {
  flex: 1 1 100%;
  max-width: 100%;
}

/* Price configuration message styles */
.price-config-message {
  width: 100%;
  padding: 0 15px; /* Align with the columns above */
}

.input--missing {
  border: rgb(252, 30, 30) solid 1px;
  border-radius: 4px;
  background-color: rgb(214, 214, 214);
}
.logistics-email-choice {
  padding: 10px 12px;
  border: 1px solid #d9dee3;
  border-radius: 6px;
  background: #f8f9fa;
}
.logistics-email-choice--invalid {
  border-color: #fc1e1e;
  background: #fff1f1;
}
.flex-row {
  display: flex;
  flex-flow: row;
}
.hrLine {
  border: dotted grey 1px;
  margin-top: 1.15rem;
}
.define-zone-text {
  text-decoration: underline;
  cursor: pointer;
}
</style>
